export const createGetConnectedLinkedinCompanyPagesRequest = (disableLoading = false) => {
  return {
    url: "/linked_in_company_pages",
    method: "GET",
    disableLoading,
  };
};

export const createGetAllUserManagedLinkedinCompanyPagesRequest = (
  linkedInAccountId,
  workspaceId,
  disableLoading = false
) => {
  return {
    url: `/linked_in_company_pages/all?linked_in_account_id=${linkedInAccountId}&workspace_id=${workspaceId}`,
    method: "GET",
    disableLoading,
  };
};

export const createConnectLinkedinCompanyPageRequest = (data) => {
  return {
    url: "/linked_in_company_pages/connect",
    method: "POST",
    data: {
      temp_token: data,
    },
  };
};

export const createDisconnectLinkedinCompanyPageRequest = (
  companyPageId
) => {
  return {
    url: "/linked_in_company_pages",
    method: "DELETE",
    data: {
      linked_in_company_page_id: companyPageId,
    },
  };
};

export const createGetPageInfoByCompanyUrl = (companyUrl, postIdentity = {}) => {
  return {
    url: "/linked_in_company_pages/info",
    method: "GET",
    params: {
      company_url: companyUrl,
      ...postIdentity,
    },
  };
};
